/**
 * B2BSalesRegisterService.ts
 * API calls for the B2B Sales Register (GST) report.
 * Adjust `API_BASE` / axios instance import to match your project's existing
 * pattern (e.g. the same base used by InvoicePageService.ts).
 */

import axios from "../utils/axiosConfig";
import { BASE_URL } from "../utils/urls";
export interface IB2BSalesRegisterFilters {
  fromDate?: string;
  toDate?: string;
  month?: string; // "YYYY-MM"
  financialYear?: string; // "YYYY-YY" e.g. "2025-26"
  customerId?: string;
  gstin?: string;
  state?: string;
  search?: string;
  sortField?: string;
  sortOrder?: "asc" | "desc";
  page?: number;
  limit?: number;
}

function buildQuery(orgId: string, filters: IB2BSalesRegisterFilters): string {
  const params = new URLSearchParams();
  params.append("orgId", orgId);
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, String(value));
    }
  });
  return params.toString();
}

/** Paginated fetch — used to populate the on-screen grid */
export async function getB2BSalesRegister(orgId: string, filters: IB2BSalesRegisterFilters) {
  const qs = buildQuery(orgId, filters);
  const res = await axios.get(`${BASE_URL}/api/invoice/b2bSalesRegister?${qs}`);
  return res.data;
}

/** Full (unpaginated) fetch of ALL filtered rows — used for PDF / Excel / CSV export */
export async function getB2BSalesRegisterExport(orgId: string, filters: IB2BSalesRegisterFilters) {
  const { page, limit, ...rest } = filters;
  const qs = buildQuery(orgId, rest);
  const res = await axios.get(`${BASE_URL}/api/invoice/b2bSalesRegister/export?${qs}`);
  return res.data;
}